<template>
    <div class="max-width-content">
        <trashed-message v-if="blog.deleted_at" class="mb-6" @restore="restore">
            This blog has been deleted.
        </trashed-message>

        <breadcrumbs>
            <inertia-link :href="route('admin.blogs.index')">Blog</inertia-link>
            <i class="fad fa-chevron-right"></i>
            <inertia-link :href="route('admin.blogs.show', blog.id)">{{ blog.title | truncate(35) }}</inertia-link>
            <i class="fad fa-chevron-right"></i>
            Wijzig
        </breadcrumbs>

        <div class="mt-5 bg-white rounded-lg px-8 py-5">
            <blog-form :blog="blog" :categories="categories" @submit="submit" :data-loading="loading"></blog-form>
        </div>
    </div>
</template>

<script>
import Layout from "@/admin/Shared/Layout";
import Helpers from "@/admin/Mixins/GeneralHelpers.js";
import TrashedMessage from "@/admin/Shared/TrashedMessage";
import Breadcrumbs from "@/admin/Shared/Breadcrumbs";
import BlogForm from "@/admin/Pages/Blog/BlogForm";

export default {
    metaInfo() {
        return { title: this.blog.title };
    },

    layout: (h, page) => h(Layout, [page]),

    components: {
        TrashedMessage,
        Breadcrumbs,
        BlogForm
    },

    mixins: [Helpers],

    props: {
        blog: Object,
        categories: Array
    },

    data() {
        return {};
    },

    methods: {
        submit(data) {
            this.loading = "submit";

            const url = this.route("admin.blogs.update", this.blog.id).url();
            data.append("_method", "patch");
            const options = { onFinish: () => this.loading = false }

            this.$inertia.post(url, data, options)
        },

    }
};
</script>
